module.exports = __webpack_public_path__ + "static/media/introduce.0105f864.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S冷藏车/introduce.png
// module id = 722
// module chunks = 0